// extracted by mini-css-extract-plugin
module.exports = {"highestBidContainer":"VehicleHighestBid_highestBidContainer___FAek","highestBid":"VehicleHighestBid_highestBid__Q_WY7"};